import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import CheckboxField from '../../formFields/checkboxField';
import { reduxFormFieldWrapper } from '../reduxFormFieldWrapper';
export default ({ ...props }) => {
    props.type = 'checkbox';
    return reduxFormFieldWrapper(fieldProps => _jsx(CheckboxField, { ...fieldProps }))(props);
};
//# sourceMappingURL=index.js.map